import React from "react";
import styles from "./commonStyles";

const ToggleSwitch = ({ label, checked, onChange }) => {
  return (
    <div className="d-flex align-items-center mb-3 mb-md-4">
      <div
        className={`position-relative rounded-pill cursor-pointer width44 height24`}
        style={{
          backgroundColor: checked ? "#23DC9F" : "#B3A9BE",
          transition: "background-color 0.3s ease",
          cursor: "pointer",
        }}
        onClick={() => onChange(!checked)}
      >
        <span
          className="position-absolute bg-white rounded-circle top4 width16 height16"
          style={{
            left: checked ? "24px" : "4px",
            transition: "left 0.3s ease",
          }}
        />
      </div>
      <span className="ms-2 text-white fontSize12Regular">{label}</span>
    </div>
  );
};

export default ToggleSwitch;
